import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import DrawerAppBar from './layouts/Header';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import PropTypes from 'prop-types';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Works from './pages/Works';
import About from './pages/About';
import Skills from './pages/Skills';
import Footer from './layouts/Footer';

const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#c5c4c4',
      },
    },
});

function useIsInViewport(ref) {
    const [isIntersecting, setIsIntersecting] = React.useState(false);
  
    const observer = React.useMemo(
      () =>
        new IntersectionObserver(([entry]) =>
          setIsIntersecting(entry.isIntersecting),
        ),
      [],
    );
  
    React.useEffect(() => {
      observer.observe(ref.current);
  
      return () => {
        observer.disconnect();
      };
    }, [ref, observer]);
  
    return isIntersecting;
}


function HideOnScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
      target: window ? window() : undefined,
    });
  
    return (
      <Slide appear={false} direction="down" in={!trigger}>
        {children}
      </Slide>
    );
}

HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    window: PropTypes.func,
};

export default function Landing(props) {
    const aboutRef = React.useRef(null);
    const skillsRef = React.useRef(null);
    const projectsRef = React.useRef(null);
    const [currentView, setCurrentView] = React.useState('About')

    const aboutViewPort = useIsInViewport(aboutRef);
    const projectsViewPort = useIsInViewport(projectsRef);
    const skillsViewPort = useIsInViewport(skillsRef);

    const handleNav = (value) => {
        if (value === 'About') {
            aboutRef.current.scrollIntoView({ behavior: 'smooth' })
        }
        if (value === 'Works') {
            projectsRef.current.scrollIntoView({ behavior: 'smooth' })
        }
        if (value === 'Skills') {
            skillsRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    React.useEffect(() => {
        if (aboutViewPort) {
            setCurrentView('About')
        }
        if (projectsViewPort) {
            setCurrentView('Works')
        }
        if (skillsViewPort) {
            setCurrentView('Skills')
        }
      }, [aboutViewPort,projectsViewPort,skillsViewPort]);


    return (
        <React.Fragment>
            <CssBaseline  />
            <ThemeProvider theme={darkTheme}>
                <DrawerAppBar handleNav={handleNav} setCurrentView={setCurrentView} currentView={currentView}/>
                <Grid 
                    sx={{ px: { lg: 10, md: 10, sm:10, xs:3 } }}
                    container 
                    direction="row"
                    justifyContent="center"
                    alignItems="center">
                    <Grid pt={10} ref={aboutRef} item lg={12} md={12} sm={12} xs={12} >
                        <About/>
                    </Grid>
                    <Grid pt={10} ref={projectsRef} item lg={12} md={12} sm={12} xs={12}>
                        <Works/>
                    </Grid>
                    <Grid pt={10} ref={skillsRef} sx={{fontSize:60, textAlign:'center'}} item lg={12} md={12} sm={12} xs={12}>
                        <Skills/>
                    </Grid>
                    <Grid sx={{textAlign:'center'}} item lg={12} md={12} sm={12} xs={12}>
                        <Footer/>
                    </Grid>
                </Grid>
            </ThemeProvider>
        </React.Fragment>
    );
}